// The single place the console is written to. Callers log through this so
// diagnostics stay visible in the browser devtools while the console API is
// referenced exactly once per level (see the project's no-console policy).
/* eslint-disable no-console */
export const logger = {
  warn: (...args) => console.warn(...args), // NOSONAR - the one sanctioned console sink
  error: (...args) => console.error(...args), // NOSONAR - the one sanctioned console sink
};
